import React from 'react';
import styled from "styled-components"

const TextValue = styled.span`
  text-transform: uppercase;
  color: #0a0a0a;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
`
const TextType = styled.span`
  text-transform: uppercase;
  color: #0a0a0a;
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
`

const DateTimeDisplay = ({ value, type }) => {
  return (
    <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
      <TextValue>{value}</TextValue>
      <TextType>{type}</TextType>
    </div>
  );
};

export default DateTimeDisplay;
